import React from "react";
import Typography from "@material-ui/core/Typography";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { has_at_least_one_element } from "../../helper/utils";
import { get_user_role, replace_site_url } from "../../helper/helpers";
import "./card.scss";

const DrugCard = ({ el, types, assessments, should_expand }) => {
  const assessments_local =
    typeof assessments == "undefined" || assessments.length > 0
      ? assessments.concat(["199"])
      : [];
  const [user_expanded, setUserExpanded] = React.useState(null);
  const useStyles = makeStyles((theme) =>
    createStyles({
      root: {
        width: "100%",
      },
      heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
      },
    })
  );
  const classes = useStyles();

  // Filter drug_assessment.items to only include topics that were passed down to our props
  // in the assessments array.
  const filtered_drug_assessments = el.drug_assessment.items.filter((el) =>
    has_at_least_one_element(el.topic_ids, assessments)
  );
  const filtered_drug_sheets = el.drug_factsheet.items.filter((el) =>
    has_at_least_one_element(el.topic_ids, assessments)
  );

  const filtered_interaction = el.drug_interaction.items.filter((el) =>
    has_at_least_one_element(el.topic_ids, assessments_local)
  );

  var assessment = (
    <Typography component="div">
      {filtered_drug_assessments.map((sub, subindex) => {
        return (
          <div key={subindex} className="drug_assment_section">
            <h4>{el.drug_assessment.title}</h4>
            <a
              key="anchor-{subindex}"
              target="_PARENT"
              href={replace_site_url(sub.url)}
            >
              {sub.topics}
              <br />
              <span>{sub.specifications}</span>
              <br />
              <span>{sub.specifications2}</span>
            </a>
          </div>
        );
      })}
    </Typography>
  );
  var factsheet = (
    <Typography component="div">
      {filtered_drug_sheets.map((item, i) => (
        <div key={i} className="fact_sheets_section">
          <h4>{el.drug_factsheet.title}</h4>
          <a key={i} target="_PARENT" href={replace_site_url(item.url)}>
            {item.topics}
            <br />
            <span>{item.specifications}</span>
            <br />
            <span>{item.specifications2}</span>
          </a>
        </div>
      ))}
    </Typography>
  );
  var interaction = (
    <Typography component="div">
      {filtered_interaction.map((item, i) => (
        <div key={i} className="drug_interaction_section">
          <h4>{el.drug_interaction.title}</h4>
          <a key={i} target="_PARENT" href={replace_site_url(item.url)}>
            {item.title}
            <br />
            <span>{item.specifications}</span>
            <br />
            <span>{item.specifications2}</span>
          </a>
        </div>
      ))}
    </Typography>
  );
  var card_is_hidden = false;
  if (types.length > 0) {
    card_is_hidden = true;
    let internal_rows = 0; // How many rows will this card disaply to the user
    if (!types.includes("Factsheets")) {
      factsheet = <React.Fragment />;
    } else {
      internal_rows += filtered_drug_sheets.length;
    }
    if (!types.includes("Frühe Nutzenbewertungen")) {
      assessment = <React.Fragment />;
    } else {
      internal_rows += filtered_drug_assessments.length;
    }
    if (!types.includes("Wechselwirkungen und Nebenwirkungen")) {
      interaction = <React.Fragment />;
    } else {
      internal_rows += filtered_interaction.length;
    }
    if (internal_rows > 0) {
      card_is_hidden = false;
    }
  }
  if (card_is_hidden) {
    return <React.Fragment />;
  }
  const onClick = (event) => {
    setUserExpanded(!expanded);
  };
  const expanded = user_expanded === null ? should_expand : user_expanded;
  return (
    <Accordion key={el.atc_code} expanded={expanded}>
      <AccordionSummary
        onClick={onClick}
        expandIcon={
          <div className="wrapper-circle">
            <ExpandMoreIcon />
          </div>
        }
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography className={classes.heading}>
          {el.title} {get_user_role(el)}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {assessment}
        {factsheet}
        {interaction}
      </AccordionDetails>
    </Accordion>
  );
};
export default DrugCard;
